
import MicrosoftTermination01Template from '@/templates/ms365/MicrosoftTermination01Template.vue';
import {
  sendAuthTokenAndGetAuthToken,
  isAuthValueConincide,
  getUserDetail,
  getHostingDetail,
  getServiceRevokeInfo,
  getLicenseRevokeInfo,
  revokeService,
  revokeLicense,
} from '@/api/proxy/gapi';
import { RouterType } from '@/router/types';
import { TerminationFormState, TerminationType } from '@/types/common/goods';
import Vue from 'vue';
import type { RevokeServiceParamsData } from '@/api/proxy/gapi/types';

export default Vue.extend({
  components: {
    MicrosoftTermination01Template,
  },
  data() {
    return {
      formState: {
        authenticateState: {
          isAuthenticated: false,
          target: {
            owner: true,
            manager: false,
          },
          method: {
            sms: true,
            email: false,
          },
          authValue: null,
          ownerMobile: '',
          ownerEmail: '',
          managerMobile: '',
          managerEmail: '',
        },
        revokeState: {
          bankName: '',
          accountNumber: '',
          accountName: '',
        },
        isAgree: false,
      } as TerminationFormState,
      templateState: {
        service: '',
        domain: '',
        license: {
          value: '',
          warning: '',
        },
        isShowAuthenticatedSection: true,
        isLoading: false,
        refund: {
          origin_code: '',
          carve_code: '',
          ordernum: '',
        },
      },
      errors: {
        authenticate: null as any,
      },
      authenticate: {
        auth_type: 'owner' as 'owner' | 'manager',
        cert_type: 'sms' as 'sms' | 'email',
        auth_token: '',
      },
    };
  },
  computed: {
    serviceSeq(): number {
      return this.$store.state.goodsInfo.serviceId;
    },
    terminationType(): TerminationType {
      return this.$store.state.goodsInfo.type;
    },
  },
  async created() {
    const hostingDetail = await getHostingDetail(this.serviceSeq);

    if (!hostingDetail) {
      alert('잘못된 접근입니다.');
      window.location.href = process.env.VUE_APP_GABIA_URL;
      return;
    }

    const [userDetail, serviceRevokeInfo, licenseRevokeInfo] = await Promise.all([
      getUserDetail(),
      getServiceRevokeInfo(this.serviceSeq),
      getLicenseRevokeInfo(this.serviceSeq),
    ]);

    this.$console.log(serviceRevokeInfo);
    this.$console.log(licenseRevokeInfo);

    if (this.terminationType === TerminationType.SERVICE) {
      // 서비스 해지
      if (!serviceRevokeInfo) {
        alert('해지 가능한 서비스가 없습니다.');
        window.location.href = process.env.VUE_APP_GABIA_URL;
      }
      this.templateState.license.value = ` ${serviceRevokeInfo?.order.name} ${serviceRevokeInfo?.order.license_count}개`;
      this.templateState.license.warning = `${this.getDiffTimeStringFromNow(
        serviceRevokeInfo.order.revoke_expire_date,
      )} 후 해지 불가`;

      // 환불
      this.templateState.refund.origin_code = 'M365_CANCEL';
      this.templateState.refund.carve_code = serviceRevokeInfo.hosting.carve_code;
      this.templateState.refund.ordernum = serviceRevokeInfo.order.ordernum || '';

      // carve_flag 값이 S가 아닌 경우 [본인 인증 여부] 노출하지 않음. (신규일때만 노출)
      if (serviceRevokeInfo.order.carve_flag !== 'S') {
        this.templateState.isShowAuthenticatedSection = false;
        // 인증을 거치지 않고 바로 넘어가도록 처리
        this.formState.authenticateState.isAuthenticated = true;
        // 환불
        this.templateState.refund.origin_code = 'M365_EXTEND_CANCEL';
      }
    } else if (this.terminationType === TerminationType.LICENSE) {
      // 추가 라이선스 해지
      if (!licenseRevokeInfo) {
        alert('해지 가능한 라이선스가 없습니다.');
        window.location.href = process.env.VUE_APP_GABIA_URL;
      }
      this.templateState.license.value = ` ${licenseRevokeInfo?.order.name} ${licenseRevokeInfo?.order.license_count}개`;
      this.templateState.license.warning = `${this.getDiffTimeStringFromNow(
        licenseRevokeInfo.order.revoke_expire_date,
      )} 후 해지 불가`;

      // 환불
      this.templateState.refund.origin_code = 'M365_LICENSE_CANCEL';
      this.templateState.refund.carve_code = licenseRevokeInfo.hosting.carve_code;
      this.templateState.refund.ordernum = licenseRevokeInfo.order.ordernum || '';

      // carve_flag 값이 S가 아닌 경우 [본인 인증 여부] 노출하지 않음. (신규일때만 노출)
      if (licenseRevokeInfo.order.carve_flag !== 'S') {
        this.templateState.isShowAuthenticatedSection = false;
        // 인증을 거치지 않고 바로 넘어가도록 처리
        this.formState.authenticateState.isAuthenticated = true;
      }
    } else {
      alert('잘못된 접근입니다.');
      window.location.href = process.env.VUE_APP_GABIA_URL;
    }

    this.formState.authenticateState.ownerMobile = userDetail?.hp_no || '';
    this.formState.authenticateState.ownerEmail = userDetail?.email || '';
    this.formState.authenticateState.managerMobile = hostingDetail?.b_mobile || '';
    this.formState.authenticateState.managerEmail = hostingDetail?.b_email || '';

    this.templateState.service = hostingDetail?.carve_name || '';
    this.templateState.domain = hostingDetail?.domain || '';

    this.$store.commit('setTerminationInfo', {
      msoffice365: {
        service: this.templateState.service,
        domain: this.templateState.domain,
        license: this.templateState.license,
      },
    });
    // this.templateState.license = serviceRevokeInfo
    //   ? ` ${serviceRevokeInfo?.order.name} ${serviceRevokeInfo?.order.license_count}개`
    //   : '';

    this.$console.log(hostingDetail);
    this.$GlobalLoading.hide();
  },
  methods: {
    getDiffTimeStringFromNow(dateStr) {
      const start = Date.now();
      const end = new Date(dateStr).getTime();

      const diff = end - start;

      const hourDiff = Math.floor(diff / (1000 * 60 * 60));
      const minDiff = Math.floor((diff - hourDiff * (1000 * 60 * 60)) / (1000 * 60));

      this.$console.log(hourDiff);
      this.$console.log(minDiff);

      return `${hourDiff === 0 ? '' : `${hourDiff}시간 `}${minDiff}분`;
    },
    async onClickSendAuthValueBtn() {
      this.$console.log('전송');
      this.errors.authenticate = {
        type: 'loading',
        message: '잠시만 기다려주세요.',
      };
      const auth_type = Object.entries(this.formState.authenticateState.target).find(([_, value]) => {
        return value === true;
      })?.[0] as 'owner' | 'manager';
      const cert_type = Object.entries(this.formState.authenticateState.method).find(([_, value]) => {
        return value === true;
      })?.[0] as 'email' | 'sms';

      // 인증 번호를 전송한 때 지정한 타입을 저장해놓기 위함.
      this.authenticate.auth_type = auth_type;
      this.authenticate.cert_type = cert_type;

      if (auth_type && cert_type) {
        try {
          const { auth_token } = await sendAuthTokenAndGetAuthToken({
            service_seq: this.serviceSeq,
            auth_type,
            cert_type,
          });
          this.authenticate.auth_token = auth_token;
          if (auth_token) {
            this.errors.authenticate = {
              type: 'info',
              message: '인증번호가 정상적으로 발송되었습니다. 입력 후 확인을 눌러주세요.',
            };
          }
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
          /**
           * 에러를 재현해볼수가 없어 이런식으로 대응
           */
          let message = '불특정 에러가 발생했습니다. 고객센터에 연락해주시기 바랍니다. (1544-4370)';

          if (error?.message) {
            message = error.message;
          }

          alert(message);
        }
      }
    },
    async onClickAuthCheckBtn() {
      this.$console.log('체크');

      if (!this.formState.authenticateState.authValue) {
        this.errors.authenticate = {
          type: 'error',
          message: '인증번호를 입력해 주세요.',
        };
        return;
      }

      const authData = await isAuthValueConincide({
        service_seq: this.serviceSeq,
        auth_type: this.authenticate.auth_type,
        cert_type: this.authenticate.cert_type,
        auth_value: this.formState.authenticateState.authValue || -1,
        auth_token: this.authenticate.auth_token,
      });

      if (authData && authData.auth_token === this.authenticate.auth_token) {
        this.formState.authenticateState.isAuthenticated = true;
        this.errors.authenticate = {
          type: 'info',
          message: '본인 인증 완료',
        };
        this.$GabiaModal.hide('authenticate-info-modal');
      } else {
        this.errors.authenticate = {
          type: 'error',
          message: '인증번호가 다릅니다. 다시 입력해 주세요.',
        };
      }
    },
    async onClickNextStepBtn() {
      // [확인] 누른 다음

      const $root = document.getElementById('modal-root');

      // @ts-ignore
      const { layerStore } = $root;

      if (layerStore) {
        if (process.env.VUE_APP_MODE === 'development') {
          console.log('/----base_info----/');
          console.log({
            origin_code: this?.templateState?.refund?.origin_code,
            carve_code: this?.templateState?.refund?.carve_code,
            service_name: null,
            service_termination_url: null,
            order_numbers: this?.templateState?.refund.ordernum ? [this.templateState.refund.ordernum] : [],
          });
          console.log('/----base_info----/');
        }

        layerStore.getState().openRefundRegisterModal({
          callback: async (res) => {
            if (this.templateState.isLoading) {
              return;
            }

            if (!res.data.data.seq) {
              return;
            }

            this.templateState.isLoading = true;
            this.$GlobalLoading.show();
            let result = null as any;

            if (this.terminationType === TerminationType.SERVICE) {
              // [front] 서비스 환불 신청 (https://confluence.gabia.com/pages/viewpage.action?pageId=106594691)
              const payload = {
                service_seq: String(this.serviceSeq || ''),
                user_id: this.$store.state.userInfo?.user_id || '',
                refund_seq: res.data.data.seq,
              } as RevokeServiceParamsData;
              if (this.templateState.isShowAuthenticatedSection) {
                payload.auth_token = this.authenticate.auth_token;
              }
              result = await revokeService(payload);
            } else if (this.terminationType === TerminationType.LICENSE) {
              // [front] 구독 환불 신청 (https://confluence.gabia.com/pages/viewpage.action?pageId=106594748)
              const payload = {
                service_seq: String(this.serviceSeq || ''),
                user_id: this.$store.state.userInfo?.user_id || '',
                refund_seq: res.data.data.seq,
              };
              result = await revokeLicense(payload);
            }

            if (process.env.VUE_APP_MODE === 'development') {
              console.log('/----result----/');
              console.log(result);
              console.log('/----result----/');
            }

            layerStore.getState().closeRefundRegisterModal();

            if (result?.isSuccess) {
              this.$router.push({ name: `${RouterType.TERMINATION}-02`, params: { service_code: 'msoffice365' } });
            } else {
              alert('해지 신청에 실패하였습니다.');
              if (
                process.env.VUE_APP_MODE !== 'production' &&
                confirm('test: 해지 신청에 실패하였으나 해지 신청 완료 페이지로 이동해볼까요?')
              ) {
                this.$router.push({ name: `${RouterType.TERMINATION}-02`, params: { service_code: 'msoffice365' } });
              }
            }
            this.$GlobalLoading.hide();
            this.templateState.isLoading = false;
          },
          unauthCallback: () => {
            alert('자동 로그아웃 되었습니다. 재 로그인 후 계좌를 등록해 주세요.');
            window.location.reload();
          },
          base_info: {
            origin_code: this?.templateState?.refund?.origin_code,
            carve_code: this?.templateState?.refund?.carve_code,
            service_name: null,
            service_termination_url: null,
            order_numbers: this?.templateState?.refund.ordernum ? [this.templateState.refund.ordernum] : [],
          },
        });
      }
    },
  },
});
